import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=6cfb1f72&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cfb1f72')) {
      api.createRecord('6cfb1f72', component.options)
    } else {
      api.reload('6cfb1f72', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=6cfb1f72&", function () {
      api.rerender('6cfb1f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-222oy4p9r8Ee2/JS/comp/ImgFallback2.vue"
export default component.exports